/* unplugin-vue-components disabled */import { render } from "./NotFound.vue?vue&type=template&id=c2353e06&scoped=true&ts=true"
import script from "./NotFound.vue?vue&type=script&lang=ts"
export * from "./NotFound.vue?vue&type=script&lang=ts"

import "./NotFound.vue?vue&type=style&index=0&id=c2353e06&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2353e06"]])

export default __exports__